import { Injectable } from '@angular/core';
import { Actions,createEffect,ofType } from '@ngrx/effects';
import { of, exhaustMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DaveActions } from '../actions/actions';
import { TaxTypeActions } from '../actions/tax-type.actions';
import { TaxTypeDataService } from '../../services/tax-type-data.service';
import { BaseActionTypes } from '../actions/base.actions';

enum ErrorCodes {
    Load = 'Steuerarten Abrufen fehlgeschlagen',
}

@Injectable()
export class TaxTypeEffects {

    Error = createEffect(
        () =>
            this.actions$.pipe(
                ofType(TaxTypeActions.loadFailure),
                map(a => BaseActionTypes.ErrorAction({Payload: { Err: a.Errors, ToasterMessage: a.ToasterMessage}})),
            )
    );

    Get = createEffect(
        () =>
            this.actions$.pipe(
                ofType(TaxTypeActions.loadRequest),
                exhaustMap(({ Payload }) => {
                    console.log('TaxType Effects - Get', Payload);
                    return this.api.get$({ /*UpdatedSince: Payload.updatedSince*/ }).pipe(
                        // withLatestFrom(this.store$.select(getTaxTypeDictionary)),
                        map((res) => {
                            // if (!isNotNullOrUndefined(Payload.updatedSince)) {
                            //     return TaxTypeActions.loadSuccess({ Payload: res });
                            // } else {
                            //     const fRes = res.filter((p) => {
                            //         const fromState = state[p.Id];
                            //         return !fromState || fromState.UpdatedAt.getTime() !== p.UpdatedAt.getTime();
                            //     });
                            console.log('TaxType Effects - Get success', res);

                                return TaxTypeActions.loadSuccess({ Payload: res });
                            // }
                        }),
                        catchError(err => of(TaxTypeActions.loadFailure({ Errors: err, ToasterMessage: ErrorCodes.Load }))),
                    );
                }),
            ),
    );

    constructor(private actions$: Actions<DaveActions>, private api: TaxTypeDataService) {}
}
